import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, Checkbox, CircularProgress } from "@mui/material";
import { useEffect, forwardRef, useState, Fragment } from "react";
import { styled, lighten, darken } from "@mui/system";
import { ExpenseTypes } from "../../app/slices/expenseTypesSlice";

export const SelectExpenseTypes = forwardRef((props, ref) => {
  const [options, setOptions] = useState([]);

  const _ExpenseTypes = useSelector(
    (state) => state.expenseTypes.expenseTypesList
  );
  const loading = useSelector(
    (state) => state.expenseTypes.expenseTypes.loading
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(ExpenseTypes.getAllList());
  }, []);

  const GroupHeader = styled("div")(({ theme }) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    borderBottom: "1px solid #e0e0e0",
    color: "white",
    backgroundColor: theme.palette.primary.main,
  }));
  const GroupItems = styled("ul")({
    padding: 0,
  });

  return (
    <Autocomplete
      ref={ref}
      options={_ExpenseTypes.data || []}
      {...props}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id == value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label="اختر نوع المصاريف"
          size="small"
          required={props.required}
          error={props.error}
          helperText={props.helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
        />
      )}
      renderGroup={(params, key) => (
        <li key={params.key}>
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
    />
  );
});
